import { ReactElement, ReactNode, useCallback } from 'react'
import { Menu } from '@ds/components'

const MenuListProps = { disablePadding: true } as const
const anchorOrigin = { vertical: 'bottom', horizontal: 'right' } as const
const transformOrigin = { vertical: 'top', horizontal: 'right' } as const

export function DesktopMainMenu({
    flyoutTrigger,
    setFlyoutTrigger,
    navigationMenuItems,
}: {
    flyoutTrigger: null | HTMLElement
    setFlyoutTrigger: (el: null | HTMLElement) => void
    navigationMenuItems: ReactNode
}): ReactElement {
    const onClose = useCallback(() => setFlyoutTrigger(null), [setFlyoutTrigger])

    return (
        <Menu
            id="profile-flyout"
            data-testid="profileFlyout"
            anchorEl={flyoutTrigger}
            MenuListProps={MenuListProps}
            keepMounted
            open={Boolean(flyoutTrigger)}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            className="desktop-only"
        >
            {navigationMenuItems}
        </Menu>
    )
}
